export default [
  {
    path: '/logistics/buyback-dynamics',
    name: 'pageBuybackDynamicsLogistics',
    meta: { title: 'page.pageBuybackDynamics', roles: ['LOGISTIC_RANSOM_PER_DAY'] },
    component: () => import('@/pages/manager/buyback-dynamics/index.vue'),
  },
]
